import React from 'react';
import { cn } from '../../utils/cn';

const TONES = {
    track: 'bg-surface-muted',
    selected: 'bg-surface font-medium text-fg shadow-card',
    idle: 'text-fg-muted hover:text-fg',
    focus: 'focus-visible:ring-focus',
};

/**
 * Small set of mutually exclusive choices shown as a segmented control (radiogroup)
 * instead of a short dropdown.
 * @param {Array<{value: string, label: React.ReactNode}>} options
 * @param {string} value
 * @param {(value: string) => void} onChange
 * @param {boolean} [disabled]
 * @param {string} [label] accessible name for the group
 */
export function Segmented({ options, value, onChange, disabled, label }) {
    return (
        <div className={cn('inline-flex rounded-lg p-0.5', TONES.track)} role="radiogroup" aria-label={label}>
            {options.map((o) => (
                <button
                    key={o.value}
                    type="button"
                    role="radio"
                    aria-checked={value === o.value}
                    disabled={disabled}
                    onClick={() => onChange(o.value)}
                    className={cn(
                        'rounded-md px-3 py-1 text-sm transition-colors outline-none focus-visible:ring-2 disabled:cursor-not-allowed',
                        TONES.focus,
                        value === o.value ? TONES.selected : TONES.idle
                    )}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
}
